<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodstransfer') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.date')"
              :subtitle="gtCode"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('apps.inventory.message.transferdate') }}</label>
                    <BaseInputDatePicker
                      v-model="form.selectedDate"
                      mode="dateTime"
                      is24hr
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.inventory.message.transfer')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group form-row">
                  <div class="col-md-12">
                    <div class="form-row">
                      <div class="col-md-6">
                        <label>{{ $t('apps.inventory.message.transferfrom') }}</label>
                        <select
                          :class="validate.pickedWarehouseIdFrom"
                          v-model="form.pickedWarehouseIdFrom"
                          class="form-control custom-select"
                          @change="handleChangeWhIdFrom"
                        >
                          <option :value="null">
                            {{ $t('placeholder.select') }}
                          </option>
                          <option
                            v-for="(item, index) in warehouses"
                            :key="index"
                            :value="item.warehouse_id"
                          >
                            {{ item.warehouse_name }}
                          </option>
                        </select>
                      </div>
                      <div
                        v-if="optionFromBinLocations.length > 1"
                        class="col-md-6">
                        <label>&nbsp;</label>
                        <BaseDropdown
                          v-model="form.pickedBinIdFrom"
                          :options="optionFromBinLocations"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="form-row">
                      <div class="col-md-6">
                        <label>{{ $t('apps.inventory.message.transferto') }}</label>
                        <select
                          :class="validate.pickedWarehouseIdTo"
                          v-model="form.pickedWarehouseIdTo"
                          class="form-control custom-select"
                          @change="handleChangeWhIdTo"
                        >
                          <option :value="null">
                            {{ $t('placeholder.select') }}
                          </option>
                          <option
                            v-for="(item, index) in warehouses"
                            :key="index"
                            :value="item.warehouse_id"
                          >
                            {{ item.warehouse_name }}
                          </option>
                        </select>
                      </div>
                      <div
                        v-if="optionToBinLocations.length > 1"
                        class="col-md-6">
                        <label>&nbsp;</label>
                        <BaseDropdown
                          v-model="form.pickedBinIdTo"
                          :options="optionToBinLocations"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <template v-if="form.pickedWarehouseIdTo">
          <section>
            <div class="col-md-12 no-padding">
              <section-header :title="$t('message.orderlist')"/>
              <OrderGT
                v-if="isRenderOrders"
                :validation="form.trickValidation"
                :data="form.orders"
                :createAble="true"
                :showProductImage="true"
                :selectedWhIdFrom="form.pickedWarehouseIdFrom"
                :selectedWhIdTo="form.pickedWarehouseIdTo"
                :pickedBinIdFrom="form.pickedBinIdFrom"
                :pickedBinIdTo="form.pickedBinIdTo"
                @submit="onSubmitOrder"
              />
            </div>
          </section>

          <section>
            <div class="col-md-12 no-padding">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('placeholder.note') }}</label>
                      <textarea
                        :placeholder="$t('placeholder.dotted')"
                        v-model="form.note"
                        class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="action-bar">
            <div
              v-if="!$store.state.app.loading"
              class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-web"
                @click="form.trickValidation++;isCreateAnother = false">{{ $t('button.save') }}</button>
            </div>
            <div
              v-if="$store.state.app.loading"
              class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-web"
                disabled><i class="fas fa-spinner spin"/></button>
            </div>
          </section>
        </template>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'
import moment from 'moment'

export default {
  name: 'GoodsTransferNew',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedWarehouseIdFrom: null,
        pickedWarehouseIdTo: null,
        pickedBinIdFrom: null,
        pickedBinIdTo: null,
        note: '',
        selectedDate: moment().toDate(),
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      validate: {
        pickedWarehouseIdFrom: '',
        pickedWarehouseIdTo: '',
      },

      isRenderOrders: true,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      nextGtCode: 'getNextGtCode',
      getMainWarehouse: 'getMainWarehouse',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getMainStock: 'getMainStock',
      getWarehouseInfo: 'getWarehouseInfo',
      dateformat: 'getDateFormat',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
    }),
    gtCode () {
      if (this.form.pickedWarehouseIdFrom) {
        return this.$t('series.gt') + ' ' + this.nextGtCode
      }
      return ''
    },
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionWarehouses () {
      const items = this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
      return items
    },
    optionFromBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseIdFrom) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
    optionToBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseIdTo) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  watch: {
    ready: function (isReady) {
      if (isReady) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 5,
        submenuAtIdx: 1,
      })
    },
    async 'form.pickedWarehouseIdFrom' () {
      // get next gtcode
      if (this.form.pickedWarehouseIdFrom !== null) {
        await this.$store.dispatch('getNextGtCode', {
          warehouse_id: this.form.pickedWarehouseIdFrom,
          short_name: this.getWarehouseInfo(this.form.pickedWarehouseIdFrom).short_name,
        })
      }
      // loading finish
      this.showFinish(this.$Progress)

      this.isRenderOrders = false
      this.form.orders = []
      setTimeout(() => this.isRenderOrders = true, 10)
    },
    async 'form.pickedWarehouseIdTo' () {
      this.isRenderOrders = false
      this.form.orders = []
      setTimeout(() => this.isRenderOrders = true, 10)
    },
    'form': {
      handler: function () {
        if (this.form.pickedWarehouseIdFrom !== null) {
          this.validate.pickedWarehouseIdFrom = ''
        }
        if (this.form.pickedWarehouseIdTo !== null) {
          this.validate.pickedWarehouseIdTo = ''
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    // set default
    this.setData()
    // ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 6,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 5,
      submenuAtIdx: 1,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    async clearForm () {
      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next gtcode
      await this.$store.dispatch('getNextGtCode', {
        warehouse_id: this.getMainWarehouse.warehouse_id,
        short_name: this.getMainWarehouse.short_name,
      })

      this.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
    onSubmitOrder (isValid, data) {
      this.validate.pickedWarehouseIdFrom = this.form.pickedWarehouseIdFrom == null ? 'is-invalid' : ''
      this.validate.pickedWarehouseIdTo = this.form.pickedWarehouseIdTo == null ? 'is-invalid' : ''

      let isInValid = !isValid || (this.form.pickedWarehouseIdFrom == null) || (this.form.pickedWarehouseIdTo == null)

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(data)
    },
    async save (data) {
      var orders = []

      for (let i in data) {
        let order = data[i]

        var getSku = this.getSkuInfoBySkuId(order.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: order.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == order.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stockOut = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdFrom)
        let stockIn = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdTo)

        const newOrder = {
          'sku_id': order.sku_id,
          'item': order.item,
          'quantity': order.quantity,
          'stockout': {
            'stock_id': stockOut.stock_id,
            'warehouse_id': stockOut.warehouse_id,
          },
          'stockin': {
            'stock_id': stockIn.stock_id,
            'warehouse_id': stockIn.warehouse_id,
          },
        }

        if (order.use_lot) {
          newOrder.stockout.lot_numbers = order.lot.selected.map((lot) => {
            return {
              'lot_id': lot.lotId,
              'lot_code': lot.lotCode,
              'bin_location_id': lot.binId,
              'unit': lot.unit,
            }
          })
          newOrder.stockin.bin_location_id = order.lot.binId
        }

        if (order.use_serial) {
          newOrder.stockout.serial_numbers = order.serial.selected.map((ser) => {
            return {
              'ser_id': ser.serId,
              'ser_code': ser.serCode,
              'bin_location_id': ser.binId,
              'serial_number': ser.serialNumber,
            }
          })
          newOrder.stockin.bin_location_id = order.serial.binId
        }

        orders.push(newOrder)
      }

      let dataSet = {
      	orders,
      	stockout: {
      		warehouse_id: this.form.pickedWarehouseIdFrom,
          bin_location_id: this.form.pickedBinIdFrom,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseIdFrom).short_name,
      	},
        stockin: {
      		warehouse_id: this.form.pickedWarehouseIdTo,
          bin_location_id: this.form.pickedBinIdTo,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseIdTo).short_name,
      	},
      	note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
        scheduled_at: this.form.selectedDate ? this.form.selectedDate.toISOString() : this.moment().toISOString(),
      }

      // save data
      var res = await this.$store.dispatch('insertGoodstransfer', dataSet)

      if (res.success) {
        let newGoodsTransfer = res.data.goodstransfer

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newGoodsTransfer.gt_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (!this.isCreateAnother) {
          // go to GoodsTransferAll page
          return this.$router.push({
            name: 'GoodsTransferEdit',
            query: {
              gt_id: newGoodsTransfer._id,
              gt_code: newGoodsTransfer.gt_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          this.clearForm()
        }
      }
    },
    async setData () {
      // set picked main warehouse id
      this.form.pickedWarehouseIdFrom = this.getMainWarehouse.warehouse_id
      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
    handleChangeWhIdFrom() {
      this.form.pickedBinIdFrom = null
    },
    handleChangeWhIdTo() {
      this.form.pickedBinIdTo = null
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodstransfer/New.vue